<template>
    <table class="tableGrid">
        <thead>
          <tr>
            <th v-for="key in columns" :key="key" @click="sortBy(key)" :class="{ active: sortKey == key }">
              {{ key | capitalize }}
              <span class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'">
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(entry, index) in filteredHeroes" :key="index" :class="[index === 0 ? 'lastResult' : '', index === 4 ? 'firstResult' : '', index === 5 ? 'transition' : '', index === 6 ? 'moyenne' : '',]">
            <td v-for="key in columns" :key="key">
              {{entry[key]}}
            </td>
          </tr>
        </tbody>
      </table>

</template>
      



    <script>
      // register the grid component
      export default {
        name: "Grid",
        props: {
          heroes: Array,
          columns: Array,
          filterKey: String
        },
        data() {
          var kk = 1;
          var sortOrders = {};
          this.columns.forEach(function(key) {
            sortOrders[key] = 1;
          });
          return {
            sortKey: "",
            sortOrders: sortOrders
          };
        },
        computed: {
          filteredHeroes() {
            var sortKey = this.sortKey;
            var filterKey = this.filterKey && this.filterKey.toLowerCase();
            var order = this.sortOrders[sortKey] || 1;
            var heroes = this.heroes;
            if (filterKey) {
              heroes = heroes.filter(function(row) {
                return Object.keys(row).some(function(key) {
                  return (
                    String(row[key])
                      .toLowerCase()
                      .indexOf(filterKey) > -1
                  );
                });
              });
            }
            if (sortKey) {
              heroes = heroes.slice().sort(function(a, b) {
                a = a[sortKey];
                b = b[sortKey];
                return (a === b ? 0 : a > b ? 1 : -1) * order;
              });
            }
            return heroes;
          }
        },
        filters: {
          capitalize: function(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
          }
        },
        methods: {
          sortBy(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
          },
          ka(){
              this.kk++;
              return this.kk;
          }
        },
      };
    </script>

    <style >



    </style>




// WEBPACK FOOTER //
// src/components/Grid.vue